import PortalIdParser from 'PortalIdParser';
import { createClient } from 'laboratory-lib';
import experiments from 'FormsUI/experiments.yaml';
export const laboratoryClient = createClient({
  quickFetchLabel: 'forms-ui-experiments',
  experiments: experiments,
  identifiers: {
    portalId: PortalIdParser.get()
  }
});
export const logExposure = experimentName => laboratoryClient.logExposure(experimentName);